import Model, { ModelErrors } from "./Model";

export interface VideoData {
  id?: number;

  video_id?: string;

  title?: string;

  title_seo?: string;

  description?: string;

  tags?: string[];

  public_private?: string;

  approved?: string;

  user_id?: number;

  length_in_seconds?: number;

  link?: string;
  player_link?: string;
  entry_player_link?: string;

  player_image?: string;

  thumb?: string;

  updated_rating?: number;

  rating_total_points?: number;

  rating_number_votes?: number;

  promoted?: string;

  original_extension?: string;

  valid_info: number;

  [propName: string]: any;
}

export default class VideoModel extends Model<VideoData> {

  /**
   * Track video upload progress
   */
  upload: { file?: any, upload_progress: number };

  /**
   * State of form data
   */
  state: Record<string, unknown>;

  cacheID = '';

  constructor(data?: VideoData, errors?: ModelErrors) {
    super(data, errors);

    this.state = {};

    this.upload = {
      upload_progress: 0,
      file: null
    }
  }

  isPendingApproval(): boolean {
    return this.data.approved === 'pending';
  }

  isApproved(): boolean {
    return this.data.approved === 'yes';
  }

  isIncomplete(): boolean {
    return ['pending_info', 'incomplete'].indexOf(this.data.approved!) > -1 || this.data.valid_info === 0;
  }

  isInvalid(): boolean {
    return this.data.source_file_status === 'invalid';
  }

  isScheduled(): boolean {
    return this.data.scheduled_for > 0;
  }

  isUploading(): boolean {
    return this.upload.upload_progress > 0 && this.upload.upload_progress < 100 || this.data.source_file_status === 'uploading';
  }

  isUploadPaused(): boolean {
    return this.data.source_file_status === 'upload_paused';
  }

  isPendingConversion(): boolean {
    return this.data.upload_progress === 100 && this.data.source_file_status ===
      null
      || this.data.source_file_status === 'pending';
  }

  isConverting(): boolean {
    return this.data.source_file_status === 'converting';
  }

  isConverted(): boolean {
    return this.data.source_file_status === 'ok';
  }

  isProcessing(): boolean {
    return this.isConverting() || this.isUploading() || this.isPendingConversion();
  }

  isDeleting(): boolean {
    return this.data.deleting === true;
  }

  isComplete(): boolean {
    return ['pending', 'yes', 'scheduled'].indexOf(this.data.approved!) !== -1;
  }

  hasSourceError(): boolean {
    if (this.errors.source_file_status) {
      return true;
    }

    return ['failed', 'invalid'].indexOf(this.data.source_file_status) > -1;
  }

  sourceCanBeReplaced(): boolean {
    if (this.isUploading() || this.isConverting() || this.isPendingConversion() || this.isEmbed()) {
      return false;
    }

    return true;
  }

  isEmbed(): boolean {
    return this.data.type === 'embed';
  }
}


export function create(data?: VideoData, errors?: ModelErrors): VideoModel {
  return new VideoModel(data, errors);
}
